import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_1558_9163)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10 5.67368C7.60586 5.67368 5.67367 7.60587 5.67367 10C5.67367 12.3941 7.60586 14.3263 10 14.3263C12.3941 14.3263 14.3263 12.3941 14.3263 10C14.3263 7.60587 12.3941 5.67368 10 5.67368ZM10 12.8118C8.45172 12.8118 7.18821 11.5483 7.18821 10C7.18821 8.45172 8.45172 7.18821 10 7.18821C11.5483 7.18821 12.8118 8.45172 12.8118 10C12.8118 11.5483 11.5483 12.8118 10 12.8118ZM14.5035 4.48821C13.9445 4.48821 13.4931 4.93962 13.4931 5.4986C13.4931 6.05758 13.9445 6.50899 14.5035 6.50899C15.0625 6.50899 15.5139 6.05969 15.5139 5.4986C15.5141 5.36587 15.4881 5.2344 15.4373 5.11174C15.3866 4.98908 15.3122 4.87763 15.2183 4.78377C15.1245 4.68992 15.013 4.6155 14.8904 4.56478C14.7677 4.51406 14.6363 4.48804 14.5035 4.48821V4.48821ZM18.4333 10C18.4333 8.83563 18.4438 7.6818 18.3784 6.51954C18.3131 5.16954 18.0051 3.97141 17.0179 2.98422C16.0286 1.99493 14.8326 1.68907 13.4826 1.62368C12.3182 1.55829 11.1644 1.56883 10.0021 1.56883C8.83774 1.56883 7.68391 1.55829 6.52164 1.62368C5.17164 1.68907 3.97352 1.99704 2.98633 2.98422C1.99703 3.97352 1.69117 5.16954 1.62578 6.51954C1.56039 7.68391 1.57094 8.83774 1.57094 10C1.57094 11.1623 1.56039 12.3182 1.62578 13.4805C1.69117 14.8305 1.99914 16.0286 2.98633 17.0158C3.97563 18.0051 5.17164 18.3109 6.52164 18.3763C7.68602 18.4417 8.83985 18.4312 10.0021 18.4312C11.1665 18.4312 12.3203 18.4417 13.4826 18.3763C14.8326 18.3109 16.0307 18.003 17.0179 17.0158C18.0072 16.0265 18.3131 14.8305 18.3784 13.4805C18.4459 12.3182 18.4333 11.1644 18.4333 10V10ZM16.577 14.9739C16.423 15.3578 16.2374 15.6447 15.94 15.94C15.6426 16.2374 15.3578 16.4231 14.9739 16.577C13.8644 17.0179 11.2298 16.9188 10 16.9188C8.77024 16.9188 6.13352 17.0179 5.02399 16.5791C4.64008 16.4252 4.35321 16.2395 4.05789 15.9421C3.76047 15.6447 3.57485 15.3599 3.42086 14.976C2.98211 13.8644 3.08125 11.2298 3.08125 10C3.08125 8.77024 2.98211 6.13352 3.42086 5.02399C3.57485 4.64008 3.76047 4.35321 4.05789 4.0579C4.35532 3.76258 4.64008 3.57485 5.02399 3.42087C6.13352 2.98212 8.77024 3.08126 10 3.08126C11.2298 3.08126 13.8665 2.98212 14.976 3.42087C15.3599 3.57485 15.6468 3.76047 15.9421 4.0579C16.2395 4.35532 16.4252 4.64008 16.5791 5.02399C17.0179 6.13352 16.9188 8.77024 16.9188 10C16.9188 11.2298 17.0179 13.8644 16.577 14.9739Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_1558_9163" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "18",
      height: "18",
      fill: "currentColor",
      transform: "translate(1 1)"
    })
  ])
], -1)

import VIconBase from '../VIconBase.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'InstagramIcon',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VIconBase, {
    name: "instagram",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2
    ]),
    _: 1
  }))
}
}

})